<template>
<div>
    <el-upload
        class="avatar-uploader"
        :action="action"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">
      <img v-if="value" :src="photo" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <el-button type="text" @click="removeImage"  style="color: red">删除</el-button>
</div>
</template>

<script>
export default {
  name: "Upload",
  data(){
    return{
      action:'https://wx.yixiankeji.com/admin/upload',
      sendMessage:{}
    }
  },
  computed:{
    photo(){
      return this.value
    }
  },
  props:['value','imgName'],
  created() {
    this.change()
  },
  methods:{
    change(){
        this.photo = this.value;
    },
    handleAvatarSuccess(res) {
      this.photo = res.url;
      this.sendMessage.imgUrl = res.url
      this.sendMessage.imgName = this.imgName
      this.$emit("newImage", this.sendMessage);
    },
    removeImage(){
      this.photo = ''
      this.sendMessage.imgUrl = ''
      this.sendMessage.imgName = this.imgName
      this.$emit("newImage", this.sendMessage);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return
      }
      return isJPG && isLt2M;
    },
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>